import { createContext, useContext } from 'react'
import type { CartoAuthContextValue } from './types'

function notReady(): never {
  throw new Error('useAuth() was called before AuthProvider mounted.')
}

export const CartoAuthContext = createContext<CartoAuthContextValue>({
  isAuthenticated: false,
  isLoading: true,
  user: undefined,
  error: undefined,
  loginWithRedirect: async () => notReady(),
  logout: async () => notReady(),
  getAccessTokenSilently: async () => notReady()
})

export function useAuth(): CartoAuthContextValue {
  return useContext(CartoAuthContext)
}
